module.exports = __webpack_public_path__ + "static/media/Growing tray for microgreens or Fodder tray3.50e80d00.webp";